
import VacancyEventCard from '@/components/vacancies/events-block/VacancyEventCard.vue'

export default {
  name: 'VacanciesEventsCards',

  //пропс нужно получить из распаковки cms обертки
  props: {
    events: {
      type: Array,
      default: [],
    },
  },
  components: {
    VacancyEventCard,
  },

  data() {
    return {
      defaultItems: [
        {
          title: 'Первая Новость Первая Новость Первая Новость Первая Новость Первая Новость',
          images: [
            {
              imageId: 64690,
              description: 'описание первой картинки',
              importantFlag: true,
            },
            {
              imageId: 64691,
              description: 'описание второй картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание третьей картинки',
              importantFlag: true,
            },
            {
              imageId: 64691,
              description: 'описание четвертой картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание третьей картинки',
              importantFlag: true,
            },
            {
              imageId: 64691,
              description: 'описание четвертой картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание третьей картинки',
              importantFlag: true,
            },
            {
              imageId: 64691,
              description: 'описание четвертой картинки',
              importantFlag: true,
            },
            {
              imageId: 64691,
              description: 'описание пятой картинки',
              importantFlag: false,
            }
          ],
        },
        {
          title: 'Вторая новость',
          images: [
            {
              imageId: 64690,
              description: 'описание первой картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание второй картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание третьей картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание четвертойкартинки',
              importantFlag: false,
            }
          ],
        },
        {
          title: 'Третья новость',
          images: [
            {
              imageId: 64690,
              description: 'описание первой картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание второй картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание третьей картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание четвертойкартинки',
              importantFlag: false,
            }
          ],
        },
        {
          title: 'четвертая новость (не должна попасть)',
          images: [
            {
              imageId: 64690,
              description: 'описание первой картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание второй картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание третьей картинки',
              importantFlag: true,
            },
            {
              imageId: 64690,
              description: 'описание четвертойкартинки',
              importantFlag: false,
            }
          ],
        },
      ],
    }
  },
  computed: {
    // подложка для подмены пропса на статику, потом удалить
    items: function() {
      if (this.events.length) {
        return this.events.slice(0, 3)
      } else return this.defaultItems.slice(0, 3); // берем 3 новости (надо выяснить с какого конца тащим)
    }
  }
};
